const RefreshRate = (company, type) => {
    if (company && company.name === 'mace') {
        return 60000
    } else {

        if (type && type == 'plant view') {
            return 500000
        } else if (type && type === "andon") {
            return 120000
        } else {
            return 75000
        }

    }

}
export default RefreshRate;